<template>
  <div :class="$style.txt">
    {{ $t('message.unsupportedType') }}
  </div>
</template>

<script>
export default {
  name: 'message-content-unsupported',
  props: {
    message: {
      type: Object,
      required: true
    }
  }
}
</script>

<style module lang="scss">
.txt {
  font-weight: 300;
  font-style: italic
}
</style>
